import React from 'react';
import { HorizontalDivider } from 'components/HorizontalDivider/HorizontalDivider';
import { Tooltip } from 'components/Tooltip/Tooltip';
import { useUser } from 'hooks/useUser';
import { ProfileIcon } from 'icons/profile';
import { formatPublicAddress } from 'utils/format';
import styles from './ProfileTooltip.module.scss';
import { routes } from 'routing/routes';
import { Link } from 'react-router-dom';

export const ProfileTooltip = () => {
  const { account, logout } = useUser();

  const profileIcon = (
    <div className={styles.profileIcon}>
      <ProfileIcon />
    </div>
  );

  return (
    <Tooltip className={styles.profileTooltip} icon={profileIcon}>
      <dl>
        {account.dusktech?.userEmail ? (
          <>
            <dt>Email</dt>
            <dd>{account.dusktech?.userEmail}</dd>
          </>
        ) : (
          <Link to={routes.login()} className={styles.breakerLogin}>
            <button className="btn btn-sm btn-primary">Breaker ID Login</button>
          </Link>
        )}
        <dt>Wallet</dt>
        {account.ethereum?.address && <dd>{formatPublicAddress(account?.ethereum?.address)} </dd>}
      </dl>
      <HorizontalDivider />
      <Link className={styles.accountLink} to={routes.duskAccount.base()}>
        Account
      </Link>
      <button className={styles.logoutButton} onClick={() => logout()}>
        Logout
      </button>
    </Tooltip>
  );
};
